import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import type { MetricValues } from '@/modules/finances/types';
import { usLocalizedNumber } from '@/modules/shared/lib/humanization';
function getShortNameForMetric(metric: string): string {
  if (metric === 'Net Expenses On-Chain') {
    return 'On-Chain';
  }
  if (metric === 'Net Expenses Off-chain') {
    return 'Off-chain';
  }
  if (metric === 'Net Protocol Outflow') {
    return 'Prtcol Outfl';
  }
  return metric;
}
function getKeyMetric(metric: string): string {
  if (metric === 'Net Expenses On-Chain') {
    return 'PaymentsOnChain';
  }
  if (metric === 'Net Expenses Off-chain') {
    return 'PaymentsOffChainIncluded';
  }
  if (metric === 'Net Protocol Outflow') {
    return 'ProtocolNetOutflow';
  }
  return metric;
}
interface SemiAnnualCellProps {
  semiannual: string;
  isTotal?: boolean;
  className?: string;
  metrics: Partial<MetricValues>;
  activeMetrics: string[];
}
function SemiAnnualCell(t0) {
  const $ = _c(20);
  const {
    metrics,
    semiannual,
    isTotal: t1,
    className,
    activeMetrics
  } = t0;
  const isTotal = t1 === undefined ? false : t1;
  const t2 = isTotal && "bg-muted -my-2";
  const t3 = !isTotal && "w-[78px]";
  const t4 = isTotal && "w-[71px]";
  let t5;
  if ($[0] !== className || $[1] !== t2 || $[2] !== t3 || $[3] !== t4) {
    t5 = cn("flex flex-1 flex-row items-center justify-center", t2, t3, t4, "not-last-of-type:after:border-border not-last-of-type:after:relative not-last-of-type:after:block not-last-of-type:after:h-12 not-last-of-type:after:border-l not-last-of-type:after:content-[\"\"]", className);
    $[0] = className;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== semiannual) {
    t6 = <div className="text-foreground mb-2 text-sm leading-[22px] font-semibold">{semiannual}</div>;
    $[5] = semiannual;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== activeMetrics || $[8] !== metrics) {
    let t8;
    if ($[10] !== metrics) {
      t8 = metric => <div key={metric} className="flex min-w-[70px] flex-col"><div className="text-muted-foreground mb-1 text-center text-xs font-normal">{getShortNameForMetric(metric)}</div><div className="text-foreground text-center text-xs leading-[18px] font-semibold">{usLocalizedNumber(metrics[getKeyMetric(metric) as keyof MetricValues] ?? 0)}</div></div>;
      $[10] = metrics;
      $[11] = t8;
    } else {
      t8 = $[11];
    }
    t7 = activeMetrics.map(t8);
    $[7] = activeMetrics;
    $[8] = metrics;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[12] !== t7) {
    t8 = <div className="flex flex-col">{t7}</div>;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t6 || $[15] !== t8) {
    t9 = <div className="flex flex-1 flex-col items-center">{t6}{t8}</div>;
    $[14] = t6;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t5 || $[18] !== t9) {
    t10 = <div className={t5}>{t9}</div>;
    $[17] = t5;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  return t10;
}
export { SemiAnnualCell, getKeyMetric, getShortNameForMetric };